import { useQuery } from '@apollo/react-hooks';
import { kmsClient } from '../../apollo';
import {
  LeadgenFormTemplatesQuery,
  LeadgenFormTemplatesQueryVariables
} from './__generated__/LeadgenFormTemplatesQuery';
import { LEADGEN_FORM_TEMPLATES_QUERY } from './leadgenFormTemplates.query';

export const useLeadgenFormTemplatesQuery = (variables: LeadgenFormTemplatesQueryVariables) => {
  return useQuery<LeadgenFormTemplatesQuery>(LEADGEN_FORM_TEMPLATES_QUERY, {
    variables,
    client: kmsClient,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  });
};
